var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-success",attrs:{"type":"button","name":"button"},on:{"click":_vm.validateOrderFab}},[_c('i',{staticClass:"far fa-share-square"}),_vm._v(" "+_vm._s(_vm.$t("SendToProduction")))])}
var staticRenderFns = []

export { render, staticRenderFns }